export default __webpack_public_path__ + "static/media/32d48cf8e80d04c22d8f641e5a3f95821581607450744.6bc33cf6.webp";